/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { constraint_full } from './constraint_full';
import type { constraint_modifier_full } from './constraint_modifier_full';
import type { unit_base_full } from './unit_base_full';
import type { unit_height_full } from './unit_height_full';
import type { unit_option_availability_full } from './unit_option_availability_full';
import type { unit_option_categories } from './unit_option_categories';
import type { unit_option_change_model_rule } from './unit_option_change_model_rule';
import type { unit_option_change_profil } from './unit_option_change_profil';
import type { unit_option_limit_full } from './unit_option_limit_full';
import type { unit_option_magic_item_category_full } from './unit_option_magic_item_category_full';
export type unit_option_full = {
  id: number;
  name: string | null;
  unit_id: number;
  unit_option_group_id: string;
  max: number | null;
  hidden: boolean;
  value_points: number;
  use_points: unit_option_full.use_points;
  parent_id: number | null;
  position: number;
  category: unit_option_categories;
  is_per_model: boolean;
  mount_id: number | null;
  is_multiple: boolean;
  is_required: boolean;
  magic_path_id: number | null;
  magic_spell_id: number | null;
  magic_standard_id: string | null;
  magic_item_id: string | null;
  organisation_id: number | null;
  army_organisation_id: number | null;
  has_choices: number | null;
  weight: number;
  height: unit_height_full | null;
  base: unit_base_full | null;
  change_profil: boolean;
  mount_and_carac_points: boolean;
  organisation_mode: unit_option_full.organisation_mode;
  model_rule_ids: Array<string>;
  magic_item_categories: Array<unit_option_magic_item_category_full>;
  availabilities: Array<unit_option_availability_full>;
  availabilityModifiers: Array<unit_option_availability_full>;
  hide_not_activated: boolean;
  is_default_in_list: boolean;
  use_all_activators: boolean;
  use_all_desactivators: boolean;
  unit_option_limits: Array<unit_option_limit_full>;
  unit_option_change_model_rules: Array<unit_option_change_model_rule>;
  unit_option_change_profils: Array<unit_option_change_profil>;
  constraints: Array<constraint_full>;
  modifiers: Array<constraint_modifier_full>;
};
export namespace unit_option_full {
  export enum use_points {
    COST = 'Cost',
    NO_COST = 'NoCost',
    FREE = 'Free',
    NO_LIMIT = 'NoLimit',
    UP_TO = 'UpTo',
  }
  export enum organisation_mode {
    UNIT = 'Unit',
    EXCLUDE_ADD_ORGANISATION = 'ExcludeAddOrganisation',
    CHANGE_UNIT_ORGANISATION = 'ChangeUnitOrganisation',
  }
}
